export enum RequestMethod {
    POST = "POST", GET = "GET"
}